export default {
	编号: '編號:',
	标题: '標題',
	操作: '操作',
	订单编号: '訂單編號',
	发布时间: '發布時間',
	发起时间: '發起時間',
	发送: '發送',
	附件: '附件',
	工单编号: '工單編號',
	工单不存在: '工單不存在',
	工单管理: '工單管理',
	工单类型: '類型',
	工单详情: '工單詳情',
	工单已关闭: '工單已關閉',
	沟通记录: '溝通記錄',
	关闭备注占位: '關閉備註（可選）',
	关闭工单: '關閉工單',
	关联订单: '關聯訂單',
	回复: '回復',
	回复内容: '回復內容',
	回复时间: '回復時間',
	加载中: '載入中',
	客服: '客服',
	客户: '客戶',
	聊天功能即将上线: '聊天功能即將上線',
	没有更多: '沒有更多',
	内容: '內容',
	请输入订单编号: '請輸入訂單編號',
	请输入工单标题: '請輸入工單標題',
	请输入工单内容: '請輸入工單內容',
	请输入回复内容: '請輸入回復內容',
	请填写内容或上传附件: '請填寫內容或上傳附件',
	请选择类型: '請選擇工單類型',
	请选择状态: '請選擇狀態',
	确认关闭工单: '確認關閉此工單？後續有問題，可以重新發起工單。',
	售后工单必须关联订单: '售後工單必須選擇一個關聯訂單',
	搜索: '搜索',
	无关联: '無關聯',
	无关联订单: '無關聯訂單',
	详情: '詳情',
	新增工单: '新增工單',
	修改: '修改',
	修改工单: '修改工單',
	业务员: '業務員',
	暂无消息: '暫無訊息',
	重置: '重置',
	状态: '狀態',
}
